import { Box, CardHeader as Header } from '@mui/material';
import React from 'react';

function CardHeader({
  title, tooltipInfo, customInfo, ...rest
}) {
  return (
    <Box
      mb="36px"
      display="flex"
      justifyContent={customInfo && 'space-between'}
      alignItems="center"
      gap={0.4}
    >
      <Header
        sx={{ padding: 0 }}
        title={title}
        titleTypographyProps={{ fontSize: 24 }}
        {...rest}
      />
      {tooltipInfo && tooltipInfo}
      {customInfo && customInfo}
    </Box>
  );
}

export default CardHeader;
